module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (64).964bd7c6.jpg";